import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';

import './Admin.less';
import { Form, Input, Button, Select, Divider, message, Spin, Row, Col, Radio } from 'antd';
import { Moment } from 'moment';
import { RouteComponentProps, withRouter, Link, Redirect } from 'react-router-dom';



import DataTable, {
    DataTableColumnProps,
    DataTableButtonReset
} from 'src/components/common/DataTable';

import TableRequestDTO from 'src/models/datatable/TableRequestDTO';
import TableResponseDTO from 'src/models/datatable/TableResponseDTO';
import DistrictFullSyncDTO from 'src/models/district/DistrictFullSyncDTO';
import DistrictApiController from 'src/api/DistrictApiController';


interface DataTableProps{
    districtId: number;
    districtName: string;
    fullSyncCompletionEndDateStudents: Moment;
    fullSyncCompletionEndDateTeachers: Moment;
    lastSyncModifiedBy: string;
    lastSyncModifiedDate: Moment;
}

interface FullSyncProps {
    districtId: number;
}


export interface AdminFullSyncReportsProps extends LocalizeContextProps, DataTableProps, RouteComponentProps<{}> {
    districtId: number;
    id: number;
}

interface AdminFullSyncReportsState {
    loading: boolean;
    tableRecords: DistrictFullSyncDTO[];
    pageRedirect: boolean;
}

class AdminFullSyncReports extends React.Component<AdminFullSyncReportsProps, AdminFullSyncReportsState> {
    constructor(props: AdminFullSyncReportsProps) {
        super(props);
        bindAllOfThis(this, AdminFullSyncReports.prototype);

        this.state = {
            tableRecords: [],
            loading: true,
            pageRedirect: false
        };
    }

    private fetchData(requestState: TableRequestDTO, checkEcho: () => boolean, callback: (response: TableResponseDTO<DistrictFullSyncDTO>) => void): void {
        this.setState({ loading: true });

        DistrictApiController.getDistrictFullSyncTableData(requestState, this.props.districtId)
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                let tableRecords = results.data.results ? results.data.results : [];

                this.setState({
                    tableRecords: tableRecords,
                    loading: false
                });
                callback(results.data);
            });
    }

    private customTableColumns(): DataTableColumnProps<DistrictFullSyncDTO>[] {
        let viewLInk = (text, record: DistrictFullSyncDTO) => Routes.getRoute(Routes.ADMIN_SYNC_RESULTS, record.id, record.districtId);

        return [
            DataTable.StandardColumns.Text('admin.adminFullSyncReports.columnHeader1', 'districtName'),
            DataTable.StandardColumns.Date('admin.adminFullSyncReports.columnHeader2', 'startTime'),
            DataTable.StandardColumns.Date('admin.adminFullSyncReports.columnHeader3', 'endTime'),
            DataTable.StandardColumns.Number('admin.adminFullSyncReports.columnHeader4', 'numberOfSchoolsSynced'),
            DataTable.StandardColumns.Link("admin.common.emulateColumnHeader", 'search', viewLInk, 'search')
        ];
    }

    render() {
        return (
            <div>
                <br /><br />
                <Divider type="horizontal" />
                <h3>{this.props.translate("admin.adminFullSyncReports.fullSyncReport")}</h3>

                <p className="bold-text">{this.props.translate("admin.addEditClient.fullSyncEndTimeStudents")}: {this.props.fullSyncCompletionEndDateStudents.toLocaleString()}</p>
                <p className="bold-text">{this.props.translate("admin.addEditClient.fullSyncEndTimeTeachers")}: {this.props.fullSyncCompletionEndDateTeachers.toLocaleString()}</p>
                <br />
                <p className="bold-text">{this.props.translate("admin.addEditClient.lastFullSyncUpdatedBy")}: {this.props.lastSyncModifiedBy}</p>
                <p className="bold-text">{this.props.translate("admin.addEditClient.lastFullSyncUpdatedOn")}: {this.props.lastSyncModifiedDate.toLocaleString()}</p>
                <DataTable
                    serverSide={true}
                    tableProps={{ rowKey: 'id', loading: this.state.loading }}
                    columns={this.customTableColumns()}
                    data={this.state.tableRecords}
                    fetchData={this.fetchData}
                    buttonBar={[
                        new DataTableButtonReset()
                    ]} />
            </div>
        );
    }
}

export default withLocalize(AdminFullSyncReports as any) as any;





// WEBPACK FOOTER //
// ./src/pages/admin/AdminFullSyncReports.tsx